import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Delete,
  GetAll,
  Status,
} from "../../../../features/admin/broadcast/broadcast/Slice";

export const IndexUse = () => {
  const dispatch = useDispatch();

  const [modalShow, setModalShow] = React.useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const country = useSelector((state) => state.broadcast.broadcast);

  const [name, setName] = useState("");

  useEffect(() => {
    fetch();
  }, [name]);

  const fetch = async (page = country?.current_page) => {
    // await dispatch(AllCountry());
    await dispatch(
      GetAll({
        name: name,
        page: page,
        per_page: country?.per_page,
      })
    );
  };


  const deleteData = async (id) => {
    try {
      await dispatch(Delete(id));
      setModalMessage("Deleted Successfully");
      setModalShow(true);
      await fetch();
      return true; // Success
    } catch (error) {
      setModalMessage("Delete Failed");
      setModalShow(true);
      console.error(error);
      return false; // Error
    }
  };

  const toggleStatus = async (id) => {
    try {
      await dispatch(Status(id));
      await fetch();
      return true; // Success
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  return {
    country,
    name,
    setName,
    fetch,
    deleteData,
    toggleStatus,
    modalMessage,
    modalShow,
    setModalShow,
  };
};
